import { defineStore } from 'pinia'
import { loadActionsAPI } from '@/services/actions-service'
import { requestTypes } from '@/constants/request-types'
import { useSurveysStore } from './surveys-store'
import { useStatesStore } from './states-store'

export const useActionsStore = defineStore('actions-store', {
  state: () => ({
    error: {},
    loading: {},
    actions: {}
  }),
  actions: {
    clear() {
      this.loading = {}
      this.error = {}
      this.actions = {}
    },
    async loadGroupActionsAction({
      groupName,
      surveyName,
      summaryActions = null,
      doneOnly = false,
      aggregate = false
    }) {
      this.loading[requestTypes.ACTIONS] = true
      try {
        const surveysStore = useSurveysStore()
        const statesStore = useStatesStore()
        const selectedAttributeSegment = statesStore.getSelectedAttributeSegment
        const surveyDetails = surveysStore.getSurveyDetails
        if (!surveyDetails) {
          throw new Error('Survey details not loaded')
        }
        let response = await loadActionsAPI({
          groupName,
          surveyName,
          summaryActions,
          doneOnly,
          aggregate,
          selectedAttributeSegment
        })
        if (!response.actions) {
          response.actions = []
        }
        const processedActions = processActionsResponse({
          response,
          surveyDetails,
          oldActions: this.actions
        })
        this.actions = processedActions
      } catch (error) {
        this.loading[requestTypes.ACTIONS] = error
        throw error
      } finally {
        this.loading[requestTypes.ACTIONS] = false
      }
    }
  }
})

const processActionsResponse = ({ response, surveyDetails, oldActions }) => {
  return {
    actionStats: response.actionStats,
    ...processSummaryActionsResponse({ response, oldActions }),
    actions: response.actions.map((a) => {
      return {
        ...a,
        messages: getMessagesForActionFromCategoryFeedback({
          action: a,
          surveyDetails
        })
      }
    })
  }
}

const processSummaryActionsResponse = ({ response, oldActions }) => {
  return {
    summaryActions: {
      ...(oldActions.summaryActions || {}),
      ...response.summaryActions
    },
    summaryActionStats: {
      ...(oldActions.summaryActionStats || {}),
      ...response.summaryActionStats
    }
  }
}

const getMessagesForActionFromCategoryFeedback = ({
  action,
  surveyDetails
}) => {
  // const foundCategory = action.categoriesWithDetails[0]
  const category = surveyDetails.details.categories.find(
    (c) => c.name === Object.keys(action.categories[0])[0]
  )
  const feedback = category.feedbacks.find((f) => {
    return f.details.actions.some((a) => a.name === action.actionName)
  })
  return feedback.details.actions.find((a) => a.name === action.actionName)
    .messages
}
